import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../picture/style';
import '../../field/style';
import '../../button/style';
import '../../select/style';
